
var COMMENT_DOM = {
    // 重置批盘页表单列表的样式
    updateCommentFormStyle() {
        var topbarDiv = document.getElementsByClassName('comment-fate-topbar')[0];
        var titleDiv = document.getElementsByClassName('comment-title-bar')[0];
        var formEditDiv = document.getElementsByClassName('layout-comment-form-edit')[0];
        var formReadDiv = document.getElementsByClassName('layout-comment-form-read')[0];
        if(titleDiv) {
            setTimeout(() => {
                titleDiv.style = '';
            }, 10);
        }
        if(topbarDiv && formEditDiv){
            setTimeout(() => {
                formEditDiv.style = '';
                formEditDiv.style.paddingTop = topbarDiv.clientHeight + 'px'; 
            }, 100);
        }
        if(topbarDiv && formReadDiv){
            setTimeout(() => {
                formReadDiv.style.paddingTop = topbarDiv.clientHeight + 'px'; 
                formReadDiv.style.paddingBottom = (window.innerHeight - topbarDiv.clientHeight) + 'px';
            }, 100);
        }
    },
    // 递归算取前面元素的高度
    iterativeAddItemHeight(curScrollY, curItem, itemClass) {
        var scrollY = curScrollY;
        function addItemHeight(curItem, itemClass) {
            var previousItem = curItem ? curItem.previousElementSibling : null;
            if(previousItem && previousItem.className.indexOf(itemClass) != -1) {
                if(itemClass == 'layout-cc-item'){
                    scrollY += (previousItem.clientHeight + 5);
                }else{
                    scrollY += previousItem.clientHeight;
                }
                addItemHeight(previousItem, itemClass);
                // console.log('addItemHeight------', previousItem, previousItem.clientHeight);
            }
        }
        addItemHeight(curItem, itemClass);
        // console.log('iteractivvvvvvve----', scrollY)
        return scrollY;
    },
    // 批盘页表单列表滚动到当前触发的大运or流年
    updateCommentFormScrollTop(curName, oldName) {
        var scrollY = 0;
        // 切换到大运列表，命盘侧边栏全部叉掉后
        if(curName == ''){
            // 把前面3个元素的
            var dYunContent = document.getElementById('dayunliunian');
            scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, dYunContent, 'layout-cc-item');
        }else {
            var curDiv = document.getElementById(curName);
            if(!curDiv) { return; }
            if(curName.indexOf('big') != -1) {
                var dayunContent = curDiv.parentNode.parentNode.parentNode.parentNode.parentNode;
                var dayunTitle = curDiv.parentNode.parentNode.parentNode.parentNode.previousElementSibling;
                // console.log('dayun------', curDiv, dayunContent, dayunTitle)
                scrollY += dayunTitle.clientHeight;
                scrollY += 10;
                scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, dayunContent, 'layout-cc-item');
                scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, curDiv, 'layout-cfc-item');
                // console.log('dayun------', curName, scrollY);
            }else if(curName.indexOf('liunian') != -1) {
                var ddYunItem = curDiv.parentNode.parentNode.parentNode.parentNode.parentNode;
                var ddYunContent = ddYunItem.parentNode.parentNode.parentNode.parentNode.parentNode;
                var ddYunTitle = ddYunItem.parentNode.parentNode.parentNode.parentNode.previousElementSibling;
                var ddYunSubContent = curDiv.parentNode.previousElementSibling;
                // console.log('liunian------', curDiv, ddYunItem, ddYunContent, ddYunTitle, ddYunSubContent)
                scrollY += ddYunTitle.clientHeight;
                scrollY += (ddYunSubContent.clientHeight + 45);
                scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, ddYunContent, 'layout-cc-item');
                scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, ddYunItem, 'layout-cfc-item');
                scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, curDiv, 'layout-cfcsc-item');
                // console.log('liunian------', curName, scrollY);
            }
        }
        // 滚动到指定位置
        setTimeout(() => {
            window.scrollTo(0, scrollY);
        }, 100);

        // 新增当前active样式:删掉旧的active样式
        setTimeout(() => {
            console.log('updateCommentFormScrollTop-----', curName, oldName)
            var curActiveDiv = document.getElementById(curName),
                curActiveClass = curActiveDiv && curActiveDiv.firstChild.firstChild ? curActiveDiv.firstChild.firstChild.className : '',
                oldActiveDiv = document.getElementById(oldName),
                oldActiveClass = oldActiveDiv && oldActiveDiv.firstChild.firstChild ? oldActiveDiv.firstChild.firstChild.className : '';
            if(curActiveDiv && curActiveDiv.firstChild.firstChild) {
                var cArr = curActiveClass.split(' ');
                if(cArr.indexOf('active') == -1) {
                    cArr.push('active');
                }
                curActiveDiv.firstChild.firstChild.className = cArr.join(' ');
            }
            if(oldName != '' && curName == oldName) {
                return;
            }
            if(oldActiveDiv && oldActiveDiv.firstChild.firstChild) {
                var oArr = oldActiveClass.split(' '), index = oArr.indexOf('active');
                if(index != -1) {
                    oArr.splice(index, 1);
                }
                oldActiveDiv.firstChild.firstChild.className = oArr.join(' ');
            }
        }, 200);
    },
    updateCommentFormReadScrollTop(curName) {
        var scrollY = 0;
        if(curName == ''){
            // 把前面3个元素的
            var dYunContent = document.getElementById('dayunliunian');
            scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, dYunContent, 'layout-comment-read-content');
        }else {
            if(curName.indexOf('big') != -1) {
                scrollY = COMMENT_DOM.getCommentFormReadDayunScrollY(curName);
            }else {
                scrollY = COMMENT_DOM.getCommentFormReadLiunianScrollY(curName);
            }
        }
        // 滚动到指定位置
        setTimeout(() => {
            window.scrollTo(0, scrollY);
        }, 100);
    },
    // 获取大运标题的位置
    getCommentFormReadDayunScrollY(curName) {
        var scrollY = 0;
        var curDiv = document.getElementById(curName);
        if(!curDiv) { return scrollY; }
        var dayunContent = curDiv.parentNode.parentNode;
        var dayunTitle = curDiv.parentNode.parentNode.previousElementSibling;
        if(dayunTitle) {
            scrollY += dayunTitle.clientHeight;
        }
        scrollY += 30;
        scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, dayunContent.parentNode, 'layout-comment-read-content');
        scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, curDiv.parentNode, 'layout-clr-item');
        return scrollY;
    },
    // 获取流年标题的位置
    getCommentFormReadLiunianScrollY(curName) {
        var scrollY = 0;
        var curDiv = document.getElementById(curName);
        if(!curDiv) { return scrollY; }
        var liunianItem = curDiv.parentNode;
        var liunianContent = curDiv.parentNode.parentNode.parentNode;
        var liunianTitle = curDiv.parentNode.parentNode.previousElementSibling;
        var liunianTitleSubContent = curDiv.parentNode.firstElementChild;
        scrollY += liunianTitle ? liunianTitle.clientHeight : 0;
        scrollY += liunianTitleSubContent ? liunianTitleSubContent.clientHeight : 0;
        scrollY += 10;
        scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, liunianItem, 'layout-clr-item');
        scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, liunianContent, 'layout-comment-read-content');
        scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, curDiv, 'layout-clr-liunian-list');
        return scrollY;
    },
    // 绑定批盘表单滚动触发数据联动事件
    bindCommentFormScrollEvent(canBeEdited) {
        if(!canBeEdited) {
            window.onscroll = null;
            return;
        }
        var dYunContent = document.getElementById('dayunliunian');
        var lowestY = 0;
            lowestY = COMMENT_DOM.iterativeAddItemHeight(lowestY, dYunContent, 'layout-comment-read-content');

        var totalIdList = [], totalScrollYList = [];
        var dYunList = document.getElementsByClassName('layout-comment-list')[0];
            dYunList = dYunList ? dYunList.childNodes : [];
        for(var x = 0; x < dYunList.length; x++) {
            var totalList = dYunList[x].childNodes;
            var dayunNode = totalList[0];
            var lNianList = Array.prototype.slice.call(totalList, 1);
            if(dayunNode.clientHeight > 0) {
                totalIdList.push(dayunNode.id);
                var dYunScrollY = COMMENT_DOM.getCommentFormReadDayunScrollY(dayunNode.id);
                totalScrollYList.push(dYunScrollY);
            }
            if(lNianList.length > 0) {
                for(var y = 0; y < lNianList.length; y++) {
                    if(lNianList[y].clientHeight > 0) {
                        totalIdList.push(lNianList[y].id);
                        var lNianScrollY = COMMENT_DOM.getCommentFormReadLiunianScrollY(lNianList[y].id);
                        totalScrollYList.push(lNianScrollY);
                    }
                }
            }
        }
        window.onscroll = function() {
            var curCan = AppFate.$store.state.comment.canBeEdited;
            if(curCan) { return; }
            var commentFromRead = AppFate.$store.state.comment.fromCommentFormRead;
            if(commentFromRead) {
                setTimeout(() => {
                    AppFate.$store.state.comment.fromCommentFormRead = false;
                }, 300);
                return;
            }
            var scrollY = document.documentElement.scrollTop || document.body.scrollTop;
            for(var i = 0; i < totalScrollYList.length; i++) {
                if(scrollY > totalScrollYList[i] - 10 && scrollY <= totalScrollYList[i+1]) {
                    AppFate.$store.dispatch('minifatefortune/triggerCommentFortuneItemFunction', totalIdList[i]);
                }else if(scrollY <= lowestY) {
                    AppFate.$store.dispatch('minifatefortune/triggerCommentFortuneItemDeleteFunction', totalIdList[i]);
                    AppFate.$bus.emit('updateFortuneDom');
                }
            }
        }
    },
    // 批盘页输入框聚焦时滚动到当前位置:安卓版本
    updateCommentTextAreaScrollTop(curNode, setFormStyle) {
        var scrollY = 0;
        switch(curNode.className) {
            case 'layout-cc-content':
                // 最外层的信息输入
                var outParentNode = curNode.parentNode.parentNode.parentNode,
                    outSibNode = curNode.parentNode.parentNode.previousElementSibling;
                // scrollY += (outSibNode.clientHeight + 10);
                scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, outParentNode, 'layout-cc-item');
                // console.log('最外层的信息输入-----', curNode, outParentNode, outSibNode, scrollY)
                break;
            case 'layout-cfc-subc-paragraph':
                var lineSibNode = curNode.previousElementSibling,
                    dayunItemNode = curNode.parentNode.parentNode.parentNode.parentNode.parentNode,
                    liunianItemNode = curNode.parentNode.parentNode.parentNode.parentNode;
                
                if(lineSibNode) {
                    scrollY += (lineSibNode.clientHeight * 2 + 15);
                }
                // console.log('大运流年输入框-----', lineSibNode, dayunItemNode.className, liunianItemNode.className, scrollY)
                
                // 大运输入框
                if(dayunItemNode.className.indexOf('layout-cfc-item') != -1) {
                    var titleNode = curNode.parentNode.parentNode.parentNode.parentNode.previousElementSibling,
                        dayunItemNode = curNode.parentNode.parentNode.parentNode.parentNode.parentNode,
                        dayunTitleNode = dayunItemNode.parentNode.parentNode.parentNode.parentNode.previousElementSibling,
                        outoutSibNode = dayunItemNode.parentNode.parentNode.parentNode.parentNode.parentNode;
                    scrollY += titleNode.clientHeight;
                    scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, dayunItemNode, 'layout-cfc-item');
                    scrollY += (dayunTitleNode.clientHeight);
                    scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, outoutSibNode, 'layout-cc-item');
                }
                
                // 流年输入框
                if(liunianItemNode.className.indexOf('layout-cfcsc-item') != -1) {
                    var liunianTitleNode = curNode.parentNode.parentNode.parentNode.previousElementSibling,
                        liunianItemNode = curNode.parentNode.parentNode.parentNode.parentNode,
                        liunianDayunContentNode = liunianItemNode.parentNode.previousElementSibling,
                        liunianDayunTitleNode = liunianItemNode.parentNode.parentNode.parentNode.parentNode.previousElementSibling,
                        liunianDayunItemNode = liunianItemNode.parentNode.parentNode.parentNode.parentNode.parentNode,
                        outTitleNode = liunianDayunItemNode.parentNode.parentNode.parentNode.parentNode.previousElementSibling,
                        outItemNode = liunianDayunItemNode.parentNode.parentNode.parentNode.parentNode.parentNode;
                    scrollY += liunianTitleNode.clientHeight;
                    scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, liunianItemNode, 'layout-cfcsc-item');
                    scrollY += (liunianDayunTitleNode.clientHeight);
                    scrollY += (liunianDayunContentNode.clientHeight);
                    scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, liunianDayunItemNode, 'layout-cfc-item');
                    scrollY += (outTitleNode.clientHeight);
                    scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, outItemNode, 'layout-cc-item');
                    // console.log('流年输入框', curNode, liunianTitleNode, liunianItemNode, liunianDayunContentNode, liunianDayunItemNode)
                    // console.log('------', outTitleNode, outItemNode)
                }
                break;
            default:
                break;
        }
        
        // 滚动到指定位置
        window.scrollTo(0, scrollY);
        if(!setFormStyle) {
            return; 
        }

        // 滚动到指定位置之后，ios重置样式
        var formDiv = document.getElementsByClassName('layout-comment-form-edit')[0],
            titleDiv = document.getElementsByClassName('comment-title-bar')[0],
            topNum = parseInt(formDiv.style.paddingTop);
        setTimeout(() => {
            window.scrollTo(0, 0);
            titleDiv.style = 'position: absolute; left: 0; top: -' + titleDiv.clientHeight + 'px';
            formDiv.style = 'position: absolute; left: 0; top: ' + (topNum - scrollY - titleDiv.clientHeight) + 'px';
        }, 100);
        
    },
    // 批盘页药输入框聚焦时滚动到当前位置:安卓版本
    updateMedicineInputScrollTop(curNode, setFormStyle) {
        if(curNode == null || 
            curNode.parentNode == null ||
            curNode.parentNode.parentNode == null ||
            curNode.parentNode.parentNode.parentNode == null) { 
            return;
        }
        var scrollY = 0,
            titleNode = curNode.parentNode.parentNode.parentNode.previousElementSibling,
            outItemNode = curNode.parentNode.parentNode.parentNode.parentNode;
        scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, curNode, 'layout-ccc-line');
        scrollY += (titleNode.clientHeight + 10);
        scrollY = COMMENT_DOM.iterativeAddItemHeight(scrollY, outItemNode, 'layout-cc-item');

        // 滚动到指定位置
        window.scrollTo(0, scrollY);
        if(!setFormStyle) {
            return;
        }

        // 滚动到指定位置之后，ios重置样式
        var formDiv = document.getElementsByClassName('layout-comment-form')[0],
        topNum = parseInt(formDiv.style.paddingTop);
        setTimeout(() => {
            formDiv.style = 'position: absolute; left: 0; top: ' + (topNum - scrollY) + 'px';
            window.scrollTo(0, 0);
        }, 200);
    },
}

export {
    COMMENT_DOM
}